import { useState, useEffect } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { LOGOS, BUSINESS } from "@/data/cybernet";

const NAV = [
  { id: "servicios", label: "Servicios" },
  { id: "nosotros", label: "Nosotros" },
  { id: "catalogo", label: "Catálogo" },
  { id: "ventajas", label: "Ventajas" },
  { id: "sucursales", label: "Sucursales" },
  { id: "contacto", label: "Contacto" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const waHref = `https://wa.me/${BUSINESS.primaryWhatsapp}?text=${encodeURIComponent(
    "Hola CYBERNET, me gustaría solicitar información."
  )}`;

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full border-b transition-all ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-[#E4E4E7]"
          : "bg-white border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <button
          data-testid="header-logo-btn"
          onClick={() => scrollTo("top")}
          className="flex items-center group"
          aria-label="Ir al inicio"
        >
          <img
            src={LOGOS.mark}
            alt="CYBERNET"
            className="h-10 w-auto transition-transform duration-300 group-hover:scale-105"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-sm font-medium text-[#0A0A0A] relative py-2 group"
            >
              {n.label}
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#E10600] transition-all group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-whatsapp-btn"
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E10600] text-white text-sm font-semibold px-5 py-2.5 rounded-sm hover:bg-[#B30500] transition-colors"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2"
            aria-label="Abrir menú"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-[#E4E4E7]"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-left py-3 border-b border-[#E4E4E7] font-medium text-[#0A0A0A]"
              >
                {n.label}
              </button>
            ))}
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-[#E10600] text-white font-semibold px-5 py-3 rounded-sm"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
